module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAA60lEQVQokcXSvS9EQRQF8B+mINkI0WyhZFUqFQ2Fxh+hVRBb0W9FTUFD8EJ8lEKnV+uWbEKnkYhKq5jZ5HlZj7zGSSaTc+89OfNx+rIsU4JZnGIIK7jJN/vLlGjhAE3sFpuhRDiAOaxhMK1vKHOexwc6mEz7n8R17GEr8Wm0i0MBq1jI1UYxgyPsp9oihnGV+DO2A3awgU9s4hLrBacT8Q26WMJZSO7H6X7LuO9xxMMCv0Xnt6/6CeN4rSpuoF1VPIWnfxE38FhFPIYJPHSzPSKmLaAmBqUX6mIurvEWcIeX3MBFies7zsUw+QKPMyk1nGSbqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/fabulous.png
// module id = nTZ0
// module chunks = 0